import './styles.scss';
import { 
  library, 
  dom 
} from '@fortawesome/fontawesome-svg-core';
import { 
  faCalendarDays, 
  faHourglassStart, 
  faCar 
} from '@fortawesome/free-solid-svg-icons';
import { UIManager } from './ui.mjs';
import { AppState } from './state.mjs';
import { Experiments } from './experiments.mjs';
import { Calculator } from './calculator.mjs';
import { AppController } from './controller.mjs';

library.add(faCalendarDays, faHourglassStart, faCar);
dom.watch();

// 1. Initialiser den centrale tilstand med standardværdier
const state = new AppState();

// 2. Hent listen over aktiverede eksperimenter fra Settings og URL
const enabledExperiments = Experiments.getEnabledExperiments();

// 3. Kør injektionen
Experiments.injectExperiments(state, enabledExperiments);

// 4. Initialiser kernekomponenterne med den nu konfigurerede tilstand
const calculator = new Calculator(state);
const ui = new UIManager(state);

// 5. Generer visningen
const canvas = /** @type {HTMLCanvasElement | null} */ (document.querySelector('#chart-canvas'));
const view = ui.createView();

if (!canvas) {
  throw new Error('[App] Canvas element `#chart-canvas` was not found in DOM.');
}

const controller = new AppController(
  state,
  calculator, 
  ui, 
  canvas
);

// 4. Forbind UI med logikken via callbacks

if (view) {
  ui.bindEvents(
    () => controller.addEntryFromForm(),      // onAddEntry
    (entry) => controller.removeEntry(entry), // onRemoveEntry
    () => controller.toggleDemo(),            // onToggleDemo
    () => controller.performSync()
  );
  view.dateInput?.focus();
}

// First run
controller.performSync();